// src/contexts/EntryContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';

// 1. Definição do Contexto
// O valor padrão é { entryCity: null }
const EntryContext = createContext({ entryCity: null });

// Nome da chave no sessionStorage
const SESSION_KEY = 'entryCityData';

// 2. Componente Provedor (Provider)
// Nota: Este Provider NÃO usa useLocation ou useParams. 
// O componente Cities fará a checagem e salvará os dados.
export const EntryProvider = ({ children }) => {

    // Tenta ler os dados completos da cidade do sessionStorage
    const getInitialCity = () => {
        const storedData = sessionStorage.getItem(SESSION_KEY);
        try {
            return storedData ? JSON.parse(storedData) : null;
        } catch (e) {
            console.error("Erro ao ler dados da cidade da sessão:", e);
            return null;
        }
    };

    const [entryCity, setEntryCity] = useState(getInitialCity);

    // Função que será exposta para o Cities.js usar
    const saveEntryCity = (cityData) => {
        // Garante que só salva uma vez na sessão
        if (sessionStorage.getItem(SESSION_KEY)) {
            return;
        }

        // Salva o objeto completo no estado e no sessionStorage
        setEntryCity(cityData);
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(cityData));
    };

    // Valor fornecido: O objeto da cidade de entrada E a função para salvá-lo
    return (
        <EntryContext.Provider value={{ entryCity, saveEntryCity }}>
            {children}
        </EntryContext.Provider>
    );
};

// 3. Hook Customizado para Consumo
export const useEntryTracking = () => {
    const context = useContext(EntryContext);
    if (!context) {
        // Erro se o hook for chamado fora do provider
        throw new Error('useEntryTracking deve ser usado dentro de um EntryProvider.');
    }
    return context;
};